export default __webpack_public_path__ + "3874b7e53bbaa4771d1fca8db093d6ff.svg";